/**
 * Export file for CardTemplatesSection
 * Provides clean import path for the templates management component
 */
import CardTemplatesSection from './CardTemplatesSection';

export default CardTemplatesSection; 